/**
 * Which Agent-API ticker surface serves a Book Management mode.
 * Bet Ticker Previous uses Lab Betfair’s 7-day switch (Postgres vs BigQuery).
 */

import { shouldUseTickerBq } from './filters'

export type TickerBackend = 'pg' | 'bq'

/**
 * List backend for a mode. Previous (+ legacy previous-new) → `tickerBQ` when
 * span > 7 days or `to` is not today; otherwise Postgres `ticker`.
 */
export function tickerBackendForMode(
  modeId: string,
  from = '',
  to = '',
): TickerBackend {
  if (modeId === 'previous' || modeId === 'previous-new') {
    return shouldUseTickerBq(from, to) ? 'bq' : 'pg'
  }
  return 'pg'
}

/**
 * Filter-options backend for Sub Game → Event cascade.
 * Previous (+ New redirect) pickers use BQ; bets list uses `tickerBackendForMode`.
 */
export function filterOptionsBackendForMode(modeId: string): TickerBackend {
  if (modeId === 'previous' || modeId === 'previous-new') return 'bq'
  return tickerBackendForMode(modeId)
}

/**
 * Sub Game → Event / Event → Market cascade body for BQ filter-options.
 * Call with `dataSource: 'bq'` (Previous pickers); PG ignores cascade.
 */
export function bqFilterCascade(opts: {
  dataSource: TickerBackend
  sport: string
  event: string
}): { eventType?: string; eventName?: string } {
  if (opts.dataSource !== 'bq') return {}
  return {
    ...(opts.sport !== 'all' ? { eventType: opts.sport } : {}),
    ...(opts.event ? { eventName: opts.event } : {}),
  }
}

export function tickerListPath(dataSource: TickerBackend = 'pg'): string {
  return dataSource === 'bq' ? '/v1/book/tickerBQ' : '/v1/book/ticker'
}

export function tickerFilterOptionsPath(dataSource: TickerBackend = 'pg'): string {
  return dataSource === 'bq'
    ? '/v1/book/tickerBQ/filter-options'
    : '/v1/book/ticker/filter-options'
}
